import { Currency, ETHER, Token } from 'ulamswap-sdk'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'ULAM'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
